import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { ESignPreferenceService } from 'application/esign-preference/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class ESignPreferenceListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new ESignPreferenceService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'esign-preference',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.esign-preference.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.esign-preference.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params
                        });

                        return response.data;
                    },
                    delete: async (item) => {
                        await service.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'ESIGN_PREFERENCE.LIST.COLUMNS.NAME'
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item)
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('ESIGN_PREFERENCE.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default ESignPreferenceListViewStore;
